import React from 'react';
import PropTypes from 'prop-types';
import { StyledMenuDrawerItem, StyledMenuButton } from './HeaderMenuMobile.styles';

const Search = ({ handleMainNavClick }) => (
  <StyledMenuDrawerItem>
    <StyledMenuButton
      dataCvTest="headerMobileSearchLink"
      onClick={e => handleMainNavClick(e, 'Search Cars')}
      href="/cars"
      target="_self"
    >
      Search Cars
    </StyledMenuButton>
  </StyledMenuDrawerItem>
);

Search.propTypes = {
  handleMainNavClick: PropTypes.func.isRequired,
};

export default Search;
